module.exports = __webpack_public_path__ + "static/centerDeco-0a5c9b22905917318e687fe6e0ce856c.png";